// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dGjr5CFtTnYMu4SXHqzT{color:#007f63;font-weight:var(--font-weight-bold)}.kA8csjKJCeTxn01yCDiH{width:8rem}`, "",{"version":3,"sources":["webpack://./web/src/components/widgets/MyLatestOrderTile/MyLatestOrderTile.module.scss"],"names":[],"mappings":"AAEA,sBACI,aAAA,CACA,mCAAA,CAGJ,sBACI,UAAA","sourcesContent":["@use \"node_modules/@swordsweeper/ssi-ui-component-library/src/styles/_functions.scss\" as *;\n\n.header {\n    color: #007F63;\n    font-weight: var(--font-weight-bold);\n}\n\n.orderProgressContainer {\n    width: rem(128);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `dGjr5CFtTnYMu4SXHqzT`,
	"orderProgressContainer": `kA8csjKJCeTxn01yCDiH`
};
export default ___CSS_LOADER_EXPORT___;
